import { render } from "./PaymentReceipts.vue?vue&type=template&id=226f9686&scoped=true&ts=true"
import script from "./PaymentReceipts.vue?vue&type=script&lang=ts"
export * from "./PaymentReceipts.vue?vue&type=script&lang=ts"

import "./PaymentReceipts.vue?vue&type=style&index=0&id=226f9686&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226f9686"]])

export default __exports__